var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6406 6.28516C14.1641 2.92188 11.2109 0.625 7.875 0.625C4.51172 0.625 1.55859 2.92188 0.0820312 6.28516C0.0273438 6.42188 0 6.61328 0 6.75C0 6.88672 0.0273438 7.10547 0.0820312 7.24219C1.55859 10.6055 4.51172 12.875 7.875 12.875C11.2109 12.875 14.1641 10.6055 15.6406 7.24219C15.6953 7.10547 15.75 6.88672 15.75 6.75C15.75 6.61328 15.6953 6.42188 15.6406 6.28516ZM7.875 11.5625C5.14062 11.5625 2.625 9.73047 1.3125 6.77734C2.65234 3.79688 5.14062 1.9375 7.875 1.9375C10.582 1.9375 13.0977 3.79688 14.4102 6.75C13.0703 9.73047 10.582 11.5625 7.875 11.5625ZM7.875 3.25C5.93359 3.25 4.375 4.83594 4.375 6.75C4.375 8.69141 5.93359 10.25 7.875 10.25C9.78906 10.25 11.375 8.69141 11.375 6.77734C11.375 4.83594 9.78906 3.25 7.875 3.25ZM7.875 8.9375C6.64453 8.9375 5.6875 7.98047 5.6875 6.75C5.6875 6.75 5.6875 6.72266 5.6875 6.69531C5.82422 6.75 5.96094 6.75 6.125 6.75C7.08203 6.75 7.875 5.98438 7.875 5C7.875 4.86328 7.84766 4.72656 7.79297 4.58984C7.82031 4.58984 7.84766 4.5625 7.875 4.5625C9.07812 4.5625 10.0625 5.54688 10.0625 6.77734C10.0625 7.98047 9.07812 8.9375 7.875 8.9375Z",
    fill: "#276EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bd7b567a580711e6cf85af695ec80a8b.svg";
export { ForwardRef as ReactComponent };